import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu as MenuIcon, X, Store, Package, Settings as Cog, BarChart2, Plus, Users } from "lucide-react";
import { useState } from "react";
import AccountMenu from "./AccountMenu";
import PersonalPasswordDialog from "./PersonalPasswordDialog";

export default function DashboardShell({ children, title, restaurantName }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const isOwner = user?.role === "OWNER";
  const perms = user?.permissions || {};
  const showMenu = isOwner || perms.products_add || perms.products_edit || perms.products_delete;
  const showSummary = isOwner || perms.reports_view;
  const showSettings = isOwner || perms.hours_edit || perms.availability_toggle || perms.qr_manage;
  const showNewOrder = isOwner || perms.orders_create;

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  const NavLink = ({ to, icon: Icon, children: c, testid }) => (
    <Link to={to} onClick={() => setOpen(false)} data-testid={testid}
      className="flex items-center gap-3 rounded-2xl px-4 py-3 text-gray-800 hover:bg-orange-50 font-medium">
      <Icon size={18} className="text-orange-600" /> {c}
    </Link>
  );

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <header className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-orange-100">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-3">
            <button onClick={() => setOpen(true)} className="w-10 h-10 rounded-xl bg-orange-50 grid place-items-center" data-testid="menu-btn"><MenuIcon size={20}/></button>
            <div>
              <div className="text-xs text-gray-500">
                {restaurantName || "لوحة المطعم"}
              </div>
              <div className="font-extrabold" data-testid="page-title">{title}</div>
            </div>
          </div>
        </div>
      </header>
      {open && (
        <div className="fixed inset-0 z-30 bg-black/40" onClick={() => setOpen(false)}>
          <aside onClick={e => e.stopPropagation()} className="absolute right-0 top-0 bottom-0 w-72 bg-white p-5 rise-in">
            <div className="flex items-center justify-between mb-4">
              <AccountMenu
                user={user}
                onChangePassword={() => setPasswordDialogOpen(true)}
                onLogout={handleLogout}
              />
              <button onClick={() => setOpen(false)} className="w-9 h-9 rounded-xl bg-gray-100 grid place-items-center"><X size={18}/></button>
            </div>
            <nav className="space-y-1">
              <NavLink to="/dashboard" icon={Package} testid="nav-orders">الطلبات</NavLink>
              {showNewOrder && <NavLink to="/dashboard/new-order" icon={Plus} testid="nav-new-order">إضافة طلب</NavLink>}
              {showMenu && <NavLink to="/dashboard/menu" icon={Store} testid="nav-menu">المنيو</NavLink>}
              {showSummary && <NavLink to="/dashboard/summary" icon={BarChart2} testid="nav-summary">المبيعات</NavLink>}
              {isOwner && <NavLink to="/dashboard/employees" icon={Users} testid="nav-employees">الموظفون</NavLink>}
              {showSettings && <NavLink to="/dashboard/settings" icon={Cog} testid="nav-settings">الإعدادات</NavLink>}
            </nav>
            <div className="mt-6 text-xs text-gray-500 border-t border-orange-100 pt-4">
              <div>مرحباً <span className="font-bold text-gray-800">{user?.name}</span></div>
            </div>
          </aside>
        </div>
      )}
      {passwordDialogOpen && (
        <PersonalPasswordDialog onClose={() => setPasswordDialogOpen(false)} />
      )}
      <main className="max-w-3xl mx-auto px-4 py-4">{children}</main>
    </div>
  );
}
